//OurTeam.js

import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import OrgNode from "./TeamComponents/OrgNode.js";
import TEAM from "../Pages/data/team.js";
import { FaQuestion } from 'react-icons/fa';
import { Helmet } from "react-helmet-async";
import { Fade } from "react-awesome-reveal";
import { motion } from "framer-motion";
import '../Styles/TOrgChart.css';

function OurTeam() {
  const text = "Meet Our Team".split("");
  const gradients = ["gradient-1", "gradient-2", "gradient-3", "gradient-4"];

  return (
    <>
      <Helmet>
        <title>Our Team || Paramount Green Services</title>
        <meta name="description" content="Free heating, insulation, and solar panel grants across the UK. Transform your home’s energy efficiency today." />
      </Helmet>
      <div className="faq-wrapper">
        {/* Header */}
        <section className="faq-header text-center">
          <div className="container">
            <div className="icon-circle mb-3">
              <FaQuestion size={36} style={{ color: '#000000' }} />
            </div>
            <h1>{text.map((char, index) => (
              <motion.span
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.025, type: "spring", stiffness: 500, damping: 30 }}
              >
                {char}
              </motion.span>
            ))}</h1>
            <Fade>
              <p className="text-warning">
                Find answers to common questions about our services. Can’t find what you're looking for?
                Contact our support team anytime.
              </p>
            </Fade>
          </div>
        </section>


        <div className="team-container">
          {/* Row 1 (CEOs) */}
          <Fade delay={200} triggerOnce>
            <div className="org-row">
              {TEAM.r1.map((member, i) => (
                <OrgNode key={i} data={member} gradient={gradients[i % gradients.length]} />
              ))}
            </div>
          </Fade>
          {/* Row 2 */}
          <Fade delay={220} triggerOnce>
            <div className="org-row">
              {TEAM.r2.map((member, i) => (
                <OrgNode key={i} data={member} gradient={gradients[(i + 1) % gradients.length]} />
              ))}
            </div>
          </Fade>
          {/* Row 3 */}
          <Fade delay={240} triggerOnce>
            <div className="org-row">
              {TEAM.r3.map((member, i) => (
                <OrgNode key={i} data={member} gradient={gradients[(i + 2) % gradients.length]} />
              ))}
            </div>
          </Fade>
        </div>
      </div>
    </>
  );
}

export default OurTeam;
